<template>
  <div>
    <!-- <div :style="indent" v-if="item != undefined" @click="toggleChildren">
      {{ item.name }}
    </div> -->
    <draggable class="spis-megawrapper" v-if="item != undefined">
      <div v-if="item.id_folder != undefined" class="inside-folder fold-to-click"
        :class="depth > 0 ? 'inside-folder-folder' : ''" :style="indent" :id="'folder-' + item.id_folder"
        @click.left.exact.stop="toggleChildren(item)" @dragover="folderHover(item, '#folder-' + item.id_folder)"
        @dragleave="folderHover(null, '#folder-' + item.id_folder)" @dragend="moveFile(item)">
        <div class="inside-folder-left">
          <div class="inside-folder-icon spis-folder">
            <img class="doc-icon" src="@/assets/img/folder_icon.svg" />
          </div>
          <div class="inside-folder-txts">
            <div class="inside-folder-title">{{getFolderName(item.folder_name)}}</div>
            <!-- <div class="detalji-spisa-tiny"><span class="tezina">{{ item.item.size / 1000000 }}mb</span>
            </div> -->
          </div>
        </div>
        <div class="inside-folder-right">
          <div class="ordinal">{{ item.children != undefined ? item.children.length : 0 }}</div>
          <div class="date">{{ item.time_created != undefined ? formatDate(item.time_created) : ''}}</div>
          <div class="view" style="display: none">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="14" viewBox="0 0 24 14">
              <g>
                <g>
                  <path fill="#a2a4b0"
                    d="M23.885 6.475a.942.942 0 0 1 0 1.125c-3.044 4.04-7.17 6.528-11.72 6.528-4.55 0-8.675-2.488-11.72-6.533a.942.942 0 0 1 0-1.125C3.49 2.43 7.615-.059 12.165-.059c4.55 0 8.676 2.488 11.72 6.534zm-6.722.886A5.01 5.01 0 0 0 11.84 2.04c-2.494.156-4.516 2.176-4.671 4.669a5.01 5.01 0 0 0 5.324 5.32c2.489-.16 4.51-2.18 4.671-4.668zm-4.822 2.361A2.692 2.692 0 0 1 9.476 6.86a2.708 2.708 0 0 1 2.519-2.517 2.692 2.692 0 0 1 2.864 2.862 2.708 2.708 0 0 1-2.518 2.517z" />
                </g>
              </g>
            </svg>
          </div>
          <div v-if="is_editable && depth > 0" @click.stop="handleFolderCreateFromFolder(item)" class="add-folder">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="22" viewBox="0 0 28 22" class="folder-svg">
              <g>
                <g>
                  <path fill="#b1b3bd"
                    d="M27.721 6.067v13.471A2.46 2.46 0 0 1 25.286 22H2.555A2.46 2.46 0 0 1 .12 19.538V3.291A2.46 2.46 0 0 1 2.555.827h9.02a.338.338 0 0 1 .27.122l2.232 2.657h11.209a2.46 2.46 0 0 1 2.435 2.461zm-8.74 6.633a.979.979 0 0 0-.978-.978h-3.105V8.616a.979.979 0 0 0-1.955 0v3.106H9.838a.979.979 0 0 0 0 1.956h3.105v3.106c0 .539.438.978.977.978.54 0 .978-.44.978-.978v-3.106h3.105c.539 0 .977-.439.977-.978z" />
                </g>
              </g>
            </svg>
          </div>
          <div class="inside-folder-more" style="display: none">
            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="20" viewBox="0 0 5 20">
              <g>
                <g>
                  <path fill="#2b2a40" d="M2.086 0a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z" />
                </g>
                <g>
                  <path fill="#2b2a40" d="M2.086 7.823a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z" />
                </g>
                <g>
                  <path fill="#2b2a40" d="M2.086 15.124a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z" />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <div v-else class="inside-folder inside-folder-right" :id="'single-file-' + item.id_troskovnik" :style="indent"
        @click.left.exact.stop="handleClick(item)" @click.left.shift.exact.stop="setMultiFileSelection(item)"
        @click.left.ctrl.exact.stop="setMultiFileSelection(item)" @dblclick="openFile(item)"
        @dragstart="handleClassClick(item)" @dragend="moveFile(item)">
        <div class="inside-folder-left inside-folder-draft">
          <img class="doc-icon" src="@/assets/img/default-icon.svg" />
          <div class="inside-folder-txts">
            <div class="inside-folder-title">
              {{ item.name }}
              <span class="draft"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <g>
                    <g>
                      <path fill="#fd4087"
                        d="M10.613 10.98a.59.59 0 0 1-.59.59c-.782-.033-.782-1.148 0-1.18a.59.59 0 0 1 .59.59zm9.434-6.256c-.165 4.484-2.335 15.472-10.023 15.37C2.35 20.207.16 9.21 0 4.723c1.932.002 3.67.133 5.49-.73C7.389 3.198 8.652 1.596 10.024.12l1.646 1.78c1.616 1.763 3.897 2.83 6.27 2.823zm-4.36 6.256c-3.331-5.466-7.98-5.49-11.326 0 3.169 5.244 7.741 5.584 11.142.303zm-5.663-2.954c2.015 0 3.702 2.145 4.267 2.954-2.76 3.9-5.767 3.911-8.535-.001 1.077-1.594 2.842-3.007 4.268-2.953zm1.77 2.954c-.098-2.346-3.443-2.347-3.54 0 0 .975.794 1.768 1.77 1.768.975 0 1.77-.793 1.77-1.768z" />
                    </g>
                  </g>
                </svg></span>
            </div>
            <!-- <div class="detalji-spisa-tiny">
              <span class="tezina" v-if="(item.item.size / 1000000)>0">{{ item.item.size / 1000000 }}mb</span>
              <span class="tezina" v-else>Prazna ili neispravna datoteka</span>
            </div> -->
          </div>
        </div>
        <div class="inside-folder-right">
          <!-- <div class="ordinal">1</div> -->
          <div class="view" @click.stop="openFile()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="14" viewBox="0 0 24 14">
              <g>
                <g>
                  <path fill="#a2a4b0"
                    d="M23.885 6.475a.942.942 0 0 1 0 1.125c-3.044 4.04-7.17 6.528-11.72 6.528-4.55 0-8.675-2.488-11.72-6.533a.942.942 0 0 1 0-1.125C3.49 2.43 7.615-.059 12.165-.059c4.55 0 8.676 2.488 11.72 6.534zm-6.722.886A5.01 5.01 0 0 0 11.84 2.04c-2.494.156-4.516 2.176-4.671 4.669a5.01 5.01 0 0 0 5.324 5.32c2.489-.16 4.51-2.18 4.671-4.668zm-4.822 2.361A2.692 2.692 0 0 1 9.476 6.86a2.708 2.708 0 0 1 2.519-2.517 2.692 2.692 0 0 1 2.864 2.862 2.708 2.708 0 0 1-2.518 2.517z" />
                </g>
              </g>
            </svg>
          </div>
          <div class="date">{{ item.time_created != undefined ? formatDate(item.time_created) : '' }}</div>
          <div v-if="is_editable" @click.stop="handleFolderCreateFromFile(item)"
            class="add-folder">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="22" viewBox="0 0 28 22" class="folder-svg">
              <g>
                <g>
                  <path fill="#b1b3bd"
                    d="M27.721 6.067v13.471A2.46 2.46 0 0 1 25.286 22H2.555A2.46 2.46 0 0 1 .12 19.538V3.291A2.46 2.46 0 0 1 2.555.827h9.02a.338.338 0 0 1 .27.122l2.232 2.657h11.209a2.46 2.46 0 0 1 2.435 2.461zm-8.74 6.633a.979.979 0 0 0-.978-.978h-3.105V8.616a.979.979 0 0 0-1.955 0v3.106H9.838a.979.979 0 0 0 0 1.956h3.105v3.106c0 .539.438.978.977.978.54 0 .978-.44.978-.978v-3.106h3.105c.539 0 .977-.439.977-.978z" />
                </g>
              </g>
            </svg>
          </div>
          <div class="inside-folder-more" style="display: none">
            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="20" viewBox="0 0 5 20">
              <g>
                <g>
                  <path fill="#2b2a40" d="M2.086 0a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z" />
                </g>
                <g>
                  <path fill="#2b2a40" d="M2.086 7.823a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z" />
                </g>
                <g>
                  <path fill="#2b2a40" d="M2.086 15.124a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z" />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </draggable>

    <div>
      <tree-menu v-show="showChildren" v-for="(node, key) in item.children" :key="key" :is_editable="is_editable"
        :item="node" :depth="depth + 1" :accessToken="accessToken" @node-click="handleClick"
        @multi-select="setMultiFileSelection" @folder-create="handleFolderCreateFromFile"
        @folder-add="handleFolderCreateFromFolder" @folder-hover="folderHover" @file-move="moveFile">
      </tree-menu>
    </div>
  </div>
</template>
<script>
import share from "@/apiCallers/promise_handler_db/sharepoint";
import moment from "moment";
import draggable from "vuedraggable";

import $ from "jquery";
export default {
  props: ["item", "depth", "accessToken", "smjer", "is_editable", 'cannot_edit'],
  name: "tree-menu",
  components: {
    draggable,
  },
  data() {
    return { showChildren: true, trigg: false, loop_docs: [] };
  },

  computed: {
    indent() {
      var sirina = 100 - this.depth * 5 + "%";
      return { width: sirina };
    },
  },
  methods: {
    getFolderName(name) {
      switch (name.trim()) {
          case "Ulazni dokumenti":
          case "Ulazna pošta":
              return this.$t('page_2.page_2_5.fold_1');
          case "Izlazni dokumenti":
          case "Izlazna pošta":
              return this.$t('page_2.page_2_5.fold_2'); 
          case "Radni dokumenti":
              return this.$t('page_2.page_2_4.fold_2'); 
          case "Popratni dokumenti":
              return this.$t('page_2.page_2_4.fold_3');
          case "Naplata":
              return this.$t('page_2.page_2_7.fold_1');
          case "Računi":
              return this.$t('page_2.page_2_7.fold_2');
          case "Troškovnici":
              return this.$t('billing_page.all_doc_types[1].naziv');
          case "Nalozi za fakturiranje":
              return this.$t('billing_page.all_doc_types[2].naziv');
          case "Ostalo":
              return this.$t('billing_page.all_doc_types[3].naziv');
          default:
              return name;
      }
    },
    moveFile(file_item) {
      if (this.is_editable) {
        this.$emit("file-move", file_item);
      }
      else{
        $('.fold-to-click').removeClass("hovered-folder")
        $('.inside-folder').removeClass("eye_clicked")
      }
    },
    createNewFolder(selectedDoc) {
      var direcNameArray = selectedDoc.name.split(".");
      var tmpDirName = "";
      for (var i = 0; i < direcNameArray.length - 1; i++) {
        tmpDirName = tmpDirName + direcNameArray[i];
      }
      var tmpDirLocationId = selectedDoc.parentReference.id;
      this.createFoldToParrent(tmpDirLocationId, tmpDirName, selectedDoc);
    },
    createFoldToParrent(parrentId, docname, dItem) {
      share
        .createFolderDocs(
          this.accessToken,
          this.$route.params.uid,
          parrentId,
          docname
        )
        .then((resp) => {
          // console.log(dItem);

          var path = "/drive/items/" + dItem.id;
          var tmpDriveItem = {
            parentReference: {
              id: resp.data.id,
            },
            name: dItem.name,
          };

          share.moveDriveItem(
            this.accessToken,
            this.$route.params.uid,
            resp.data.id,
            path,
            tmpDriveItem
          );
        });
    },
    formatDate(datum) {
      return moment(datum.toString()).format("L");
    },
    openFile(item) {
      this.$store.state.troskovnik_pdf_view = true;
      this.$store.state.troskovnik_data = item.recreate_pdf_structure;
      this.$router.push('troskovnik-report')
    },

    toggleChildren(selItem) {
      this.showChildren = !this.showChildren;
      this.handleClick(selItem)
    },
    handleClick(node) {
      $(".eye_clicked").removeClass("eye_clicked");
      if (node.id_troskovnik != undefined) {
        $('#single-file-' + node.id_troskovnik).addClass("eye_clicked")
      }
      else{
        $('#folder-' + node.id_folder).addClass("eye_clicked")
      }
      this.$emit("node-click", node);
    },
    handleClassClick(node) {
      $('#single-file-' + node.id_troskovnik).addClass("eye_clicked")
    },
    setMultiFileSelection(node) {
      if(node.id_troskovnik != undefined){
        $('#single-file-' + node.id_troskovnik).addClass("eye_clicked")
        this.$emit("multi-select", node);
      }
    },
    handleFolderCreateFromFile(node) {
      this.$emit("folder-create", node);
    },
    handleFolderCreateFromFolder(node) {
      this.$emit("folder-add", node);
    },
    folderHover(node, setId) {
      if (node != null) {
        $(setId).addClass("hovered-folder")
      } else {
        $(setId).removeClass("hovered-folder")
      }
      this.$emit("folder-hover", node);
    },
    openFile() {
      this.$store.state.troskovnik_pdf_view = true;
      this.$store.state.troskovnik_data = this.item.recreate_pdf_structure;
      this.$router.push('troskovnik-report')
    },
  },

  mounted() {

    if(parseInt(this.depth+1) > 1)
    {
      this.showChildren = false;
    }
  },
  destroyed() {
    $(".inside-folder").off();
  },
};
</script>